import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const SessionExpiredDialog = () => {
  const [open, setOpen] = useState(false);
  const [type, setType] = useState('session-expired');

  useEffect(() => {
    const handleSessionExpired = () => {
      if (!localStorage.getItem('logintoken')) return;
      setType('session-expired');
      setOpen(true);
    };
    const handleLogoutSuccess = () => {
      setType('logout-success');
      setOpen(true);
    };
    window.addEventListener('session-expired', handleSessionExpired);
    window.addEventListener('logout-success', handleLogoutSuccess);
    return () => {
      window.removeEventListener('session-expired', handleSessionExpired);
      window.removeEventListener('logout-success', handleLogoutSuccess);
    };
  }, []);

  const handleOk = () => {
    setOpen(false);
    if (type === 'session-expired') {
      localStorage.clear();
      window.location.href = '/login';
    }
  };

  const isLogoutSuccess = type === 'logout-success';

  return (
    <Dialog open={open} disableBackdropClick disableEscapeKeyDown maxWidth="xs" fullWidth>
      <DialogTitle>{isLogoutSuccess ? 'Logout Successfully' : 'Session Expired'}</DialogTitle>
      <DialogContent>
        <Typography>
          {isLogoutSuccess
            ? 'You have been logged out successfully.'
            : 'Your session has expired. Please log in again.'}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOk} color="primary" variant="contained">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionExpiredDialog;
